import { assertNever } from '../../utilities/assertNever'

import { Interpunct } from './OrderedList'

/**
 * Get OrderedList's interpunct according to the passed props
 */
function getInterpunct(interpunct: Interpunct) {
  switch (interpunct) {
    case 'dot':
      return '.'
    case 'none':
      return ''
    default:
      return assertNever(interpunct)
  }
}

export default getInterpunct
